const serializeKey = (key) => `___~>__________${ key.toUpperCase() }`;
const deserializeKey = (key) => key.replace(/^___~>__________/, '').toLowerCase();

const seed = (originalConfigs) => {
  Object.keys(originalConfigs).forEach((key) => {
    if (!localStorage.getItem(serializeKey(key))) {
      localStorage.setItem(serializeKey(key), originalConfigs[key]);
    }
  });
};
export default (originalConfigs) => {
  const configs = Object.assign({}, originalConfigs);
  const overrideConfigs = {};

  seed(configs);
  Object
    .keys(configs)
    .forEach((key) => {
      if (localStorage.getItem(serializeKey(key))) {
        overrideConfigs[deserializeKey(key)] = localStorage.getItem(serializeKey(key));
      }
    });

  return overrideConfigs;
};
